"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PREVIEW_DOMAINS = void 0;
var PREVIEW_DOMAINS = {
  local: 'local.hubspotqa.com',
  prod: 'preview.hs-sites.com',
  qa: 'preview.hs-sitesqa.com'
};
exports.PREVIEW_DOMAINS = PREVIEW_DOMAINS;